import axios from 'axios'

export async function getIntegrationSettings(customerId) {
    const { data } = await axios.get(
        `${process.env.API_URL}/customers/${customerId}/external-integration-settings`
    )
    return data
}

export async function patchIntegrationSettings(customerId, body) {
    await axios.patch(
        `${process.env.API_URL}/customers/${customerId}/external-integration-settings`,
        body
    )
}
